import { render, staticRenderFns } from "./announcement-view.vue?vue&type=template&id=2f3d3f3e"
import script from "./announcement-view.vue?vue&type=script&lang=js"
export * from "./announcement-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports